/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ENABLE_SCROLL_ZOOMING, DISABLE_SCROLL_ZOOMING } from '../constants';

export default function campsite(state = {}, action) {
    const st = { ...state };

    switch (action.type) {
        case ENABLE_SCROLL_ZOOMING:
            st.disableScrollZooming = false;
            return st;
        case DISABLE_SCROLL_ZOOMING:
            st.disableScrollZooming = true;
            return st;
        default:
            return st;
    }
}
